import React, {Component} from 'react';
import {appendPossessionApostrophe} from "../../utils/string";
import {compose} from "recompose";
import {connect} from "react-redux";
import AccountTabSwitcher from "./AccountTabSwitcher";
import {isNotGuestUser} from "../../utils/userRoles";
import withUserRoleAuthorization from "../WithUserRoleAuthorization";
import {byPropKey} from "../utils";

/**
 * The forget password component.
 */
class AccountPage extends Component {
    // TODO: Require send verification email after signing in, otherwise block important functions
    constructor() {
        super();
        this.state = {
            authUserDisplayName: null
        };
    }

    componentDidMount() {
        if (this.props.authUser && this.props.authUser.displayName) {
            this.setState(byPropKey('authUserDisplayName', this.props.authUser.displayName));
        }
    }

    /**
     * Updates the display name in this component via the string
     * @param displayName
     */
    updateDisplayName = (displayName) => {
        this.setState(byPropKey('authUserDisplayName', displayName));
    };

    render() {
        return (
            <div className="container">
                <div className="row">
                    <div className="col-lg-2 col-md-1"/>
                    <div className="col-lg-8 col-md-10 col-sm-12 col-xs-12">
                        <h1>
                            {
                                this.state.authUserDisplayName
                                    ? appendPossessionApostrophe(this.state.authUserDisplayName)
                                    : this.props.authUser && appendPossessionApostrophe(this.props.authUser.email)
                            } Account
                        </h1>
                        <AccountTabSwitcher updateDisplayName={this.updateDisplayName}/>
                    </div>
                    <div className="col-lg-2 col-md-1"/>
                </div>
            </div>
        );
    }
}

/**
 * Map Redux {@param state} to component props
 */
const mapStateToProps = (state) => ({
    authUser: state.sessionState.authUser
});

/**
 * User authorization - returns {@code true} if not null (i.e. guest user)
 */
const isSignedInCondition = (authUser) => isNotGuestUser(authUser);

export default compose(
    withUserRoleAuthorization(isSignedInCondition),
    connect(mapStateToProps)
)(AccountPage);



// WEBPACK FOOTER //
// ./src/components/account/AccountPage.jsx